// src/pages/Home.js
import React from "react";
import HeroBanner from "../components/HeroBanner";
import ProductGrid from "../components/ProductGrid";

// Import images from src/assets/images
import ashtray from "../assets/images/ashtray.jpg";
import glassPipe from "../assets/images/glass-pipe.jpg";
import grinder from "../assets/images/grinder.jpg";
import vapePen from "../assets/images/vape-pen.jpg";
import woodTray from "../assets/images/wood-tray.jpg";

export default function Home() {
  const products = [
    { id: 1, name: "Ashtray", price: 49.99, img: ashtray },
    { id: 2, name: "Glass Pipe", price: 59.99, img: glassPipe },
    { id: 3, name: "Grinder", price: 39.99, img: grinder },
    { id: 4, name: "Vape Pen", price: 29.99, img: vapePen },
    { id: 5, name: "Wood Tray", price: 19.99, img: woodTray }
  ];

  return (
    <div className="pt-16">
      <HeroBanner />
      <ProductGrid products={products} />
    </div>
  );
}
